module.exports = __webpack_public_path__ + "media/images/icon-contents-disabled-f153e64bbd1f598c7ee891a3a9b11e03.svg";